import React, { useEffect, useState } from "react";
import "./Contact.css";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import RINGS from "vanta/src/vanta.rings";
import { Link } from "react-router-dom";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import Preloader from "./Preloader";

const Contact = () => {
  const [count, set_count] = useState(0);
  const [name, set_name] = useState("");
  const [email, set_email] = useState("");
  const [message, set_message] = useState("");
  const [number, set_number] = useState("");
  const [inProgression, set_in_progression] = useState(false);

  useEffect(() => {
    if (document.getElementById("hidden_div") !== null)
      document.getElementById("hidden_div").style.display = "none";
    // Initialize VANTA background
    const vantaEffect = RINGS({
      el: "#contact",
      mouseControls: true,
      touchControls: true,
      gyroControls: false,
      minHeight: 200.0,
      minWidth: 100.0,
      scale: 1.0,
      scaleMobile: 1.0,
      backgroundColor: "#023047",
    });
    setTimeout(() => {
      const PreLoad = document.getElementById("contactPreload");
      if (PreLoad) {
        PreLoad.style.display = "none";
        const body = document.getElementsByTagName("body")[0];
        body.style.overflow = "visible";
      }
    }, 2000);
    // Fetch view count on mount
    const updateCount = async () => {
      try {
        const response = await fetch("https://portfolio2-62nf.onrender.com");
        if (!response.ok) {
          throw new Error(
            `Server responded with a status of ${response.status}`
          );
        }
        const data = await response.json();
        set_count(data);
      } catch (error) {
        console.error("Failed to fetch data:", error);
      }
    };

    updateCount();

    // Clean up the VANTA effect on unmount
    return () => {
      vantaEffect.destroy();
    };
  }, []);

  const sendMail = (e) => {
    set_in_progression(true);
    // e.preventDefault()
    const data = {
      name: name,
      email: email,
      msg: message,
      number: number,
    };
    if (
      data.name.length === 0 ||
      data.email.length === 0 ||
      data.number.length === 0
    ) {
      set_in_progression(false);
      alert("You mave have left something empty !");
    } else
      try {
        fetch("https://portfolio2-62nf.onrender.com/contact", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }).then((result) => {
          result.json().then((r) => {
            alert(r.status);
            set_in_progression(false);
          });
        });
      } catch (err) {
        alert(err);
        set_in_progression(false);
      }
  };
  return (
    <>
      <Preloader id="contactPreload" />
      <div id="contact">
        <div id="contact_Outer">
          <div id="contact_form">
            <fieldset>
              <div>
                <table>
                  <thead></thead>
                  <tbody id="form1">
                    <tr>
                      <td>
                        <input
                          type="text"
                          required
                          name="name"
                          id=""
                          value={name}
                          onChange={(e) => {
                            set_name(e.target.value);
                          }}
                          placeholder="Enter you name"
                          // required
                        />
                      </td>
                      <td>
                        <input
                          type="tel"
                          required
                          // pattern="[0-9]{10}"
                          name="number"
                          value={number}
                          onChange={(e) => {
                            set_number(e.target.value);
                          }}
                          placeholder="Enter your number"
                          // required
                        />
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <input
                          type="email"
                          style={{ width: "94%" }}
                          name="email"
                          value={email}
                          onChange={(e) => {
                            set_email(e.target.value);
                          }}
                          placeholder="Enter your email id"
                          // required
                        />
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <textarea
                          name="msg"
                          id=""
                          value={message}
                          onChange={(e) => {
                            set_message(e.target.value);
                          }}
                          placeholder="Enter your message"
                          style={{ resize: "none" }}
                          rows="7"
                          // required
                        ></textarea>
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        <button onClick={sendMail} disabled={inProgression}>
                          Send
                        </button>
                      </td>
                    </tr>
                  </tbody>
                  <tbody id="form2">
                    <tr>
                      <td>
                        <input
                          type="text"
                          name="name"
                          id=""
                          value={name}
                          onChange={(e) => {
                            set_name(e.target.value);
                          }}
                          placeholder="Enter you name"
                          // required
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input
                          type="tel"
                          // pattern="[0-9]{10}"
                          value={number}
                          name="number"
                          onChange={(e) => {
                            set_number(e.target.value);
                          }}
                          placeholder="Enter your number"
                          // required
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input
                          type="email"
                          name="email"
                          value={email}
                          onChange={(e) => {
                            set_email(e.target.value);
                          }}
                          placeholder="Enter your email id"
                          // required
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <textarea
                          id=""
                          value={message}
                          name="msg"
                          onChange={(e) => {
                            set_message(e.target.value);
                          }}
                          placeholder="Enter your message"
                          style={{ resize: "none" }}
                          rows="7"
                          // required
                        ></textarea>
                      </td>
                    </tr>
                    <tr>
                      <td title="Send me mail">
                        <button onClick={sendMail} disabled={inProgression}>
                          Send
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </fieldset>
          </div>
          <div id="contact_block2">
            <div style={{ backgroundColor: "white" }} title="Total Views">
              <div id="view_icon">
                <VisibilityOutlinedIcon />
              </div>
              <hr />
              <div id="view_count">{count}</div>
            </div>
            <div id="resume_outer" style={{ display: "flex", width: "180px" }}>
              {" "}
              <div>
                <Link
                  to="https://portfolio2-62nf.onrender.com/resume.pdf"
                  title="Download my resume"
                  target="__blank"
                >
                  <CloudDownloadIcon id="resume" />
                </Link>
              </div>
              <div id="linkedin_icon">
                <Link
                  to="https://www.linkedin.com/in/pratham-singh-800a0822a/"
                  target="__blank"
                >
                  <img src="linedin.png" alt="" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
